import { render, staticRenderFns } from "./ItemPickerSearch.vue?vue&type=template&id=508a4af8&scoped=true&"
import script from "./ItemPickerSearch.vue?vue&type=script&lang=js&"
export * from "./ItemPickerSearch.vue?vue&type=script&lang=js&"
import style0 from "./ItemPickerSearch.vue?vue&type=style&index=0&id=508a4af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a4af8",
  null
  
)

export default component.exports